import React from "react";
import { Button } from "reactstrap";
import { useIntl } from "react-intl";
import { useInstagramLoginOAuth } from "../../../../cores/instagramLogin/useInstagramLoginOAuth";

interface Props {
  onSuccess?: () => void;
}

export default function InstagramLoginAuthButton({ onSuccess }: Props) {
  const intl = useIntl();
  const { startLogin } = useInstagramLoginOAuth(onSuccess);

  return (
    <Button className="w-100" color="primary" onClick={() => void startLogin()}>
      {intl.formatMessage({ id: "app.instagramLogin.connect" })}
    </Button>
  );
}
